import {Component, EventEmitter, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DateRange} from 'src/app/shared/components/date-range.component';
import {Vessel, VesselsService, VoyageLength} from 'src/app/transportation/vessels/vessels.service';
import { Subject } from 'rxjs';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import {
  PgDateRangeTitleComponent,
  PgDateRangeTitleEnum, PgTitleComponent
} from '../../../shared/components/title-bar/title-bar.component';
import { VesselReportToolbarComponent } from '../vessel-report-toolbar/vessel-report-toolbar.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AgGridModule } from 'ag-grid-angular';
import { GridOptions, GridReadyEvent } from 'ag-grid-community';
import { AgGridService } from 'src/app/shared/ag-grid/ag-grid.service';
@Component({
  selector: 'app-reports',
  templateUrl: './voyage-reports.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[SharedModule, AgGridModule]
})
export class VoyageReportsComponent implements OnInit, PgTitleComponent, PgDateRangeTitleComponent {
  title = new EventEmitter<string>();
  dateRangeSubTitle = new EventEmitter<[DateRange, PgDateRangeTitleEnum]>();

  toolbarComponentType = VesselReportToolbarComponent;
  toolbarComponent!: VesselReportToolbarComponent;

  gridOptions: GridOptions = {};

  dateRange!: DateRange;
  vessels: Vessel[] = [];
  voyages: VoyageLength[] = [];
  ports: Organisation[] = [];
  portDues: any[] = [];

  isDataTablesInitialised = false;
  dtOptions1: any;
  dtOptions3: any;
  dtTrigger: Subject<any> = new Subject<any>();

  constructor(private _activateRoute: ActivatedRoute,
              private _vesselsService: VesselsService,
              private _organisationService: OrganisationService,
              private _router: Router,
  ) { }

  columnDefs = [
    { headerName: 'Vessel', field: 'vesselName' },
    { headerName: 'Year', field: 'year' },
    { headerName: 'Quarter', field: 'quarter'},
    { headerName: 'Daily budget', field: 'dailyCost' },
  ];

  async ngOnInit() {
    this.gridOptions = AgGridService.getOptions();

    this._activateRoute.queryParams.subscribe(p => {
      const startDate = +p['startTime'];
      const endDate = +p['endTime'];
      this.dateRange = {
        startDate: new Date(startDate),
        endDate: new Date(endDate)
      };
    });
    this.title.emit('Voyages report');
    this.dateRangeSubTitle.emit([this.dateRange, PgDateRangeTitleEnum.defaultTitle]);

    this.voyages = await this._vesselsService.getVoyagesBetweenWithLengths(this.dateRange);
    this.vessels = await this._vesselsService.getVessels().toPromise() ?? [];
    this.ports = await this._organisationService.get().toPromise() ?? [];

    this.getParameters();
    this.toolbarComponent.date.subscribe(dateRange => {
      this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this._router
          .navigate(['/vessels/reports'], {
            queryParams: {
              startTime: dateRange?.startDate.getTime(),
              endTime: dateRange?.endDate.getTime()
            }
          })
          .then((e) => console.log(`Result of Navigation is ${e}`));
      });
    });

    this.dataAggregation();
  }

  gridSetting(event: GridReadyEvent) {
    AgGridService.setting(event);
  }

  getParameters() {
    this._activateRoute.queryParams.subscribe(p => {
      const startDate = +p['startTime'];
      const endDate = +p['endTime'];
      this.dateRange = {
        startDate: new Date(startDate),
        endDate: new Date(endDate)
      };
      this.toolbarComponent.dateRange = this.dateRange;
      this.title.emit('Noon Reports');
      this.dateRangeSubTitle.emit([this.dateRange, PgDateRangeTitleEnum.defaultTitle]);
    });  }

  findPort(portId: string) {
    return this.ports.find(o => portId === o.name)!.nameTranslations['en'];
  }

  dataAggregation() {
    this.portDues = this.voyages.flatMap(v => this._vesselsService.reportPortUse(v.voyage));
  }

}
